module.exports = __webpack_public_path__ + "img/dishesconfirm3.67801d18.png";